import React, { useState } from 'react';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { Button } from '../components/common/Button';

export const ContactPage = () => {
    return (
        <div className="min-h-screen flex flex-col bg-gray-50">
            <Header />
            <main className="flex-grow pt-16">
                <div className="max-w-2xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
                    <h1 className="text-3xl font-bold text-gray-900 mb-6">Contact Us</h1>
                    
                    <div className="bg-white rounded-lg shadow-sm p-6 space-y-6">
                        <p className="text-gray-600">
                            Have questions, suggestions, or need support? We'd love to hear from you! 
                            Please email us at:
                        </p>
                        
                        <a 
                            href="mailto:keepitsorted.app@gmail.com"
                            className="block text-xl font-medium text-blue-600 hover:text-blue-700 transition-colors"
                        >
                            keepitsorted.app@gmail.com
                        </a>

                        <p className="text-gray-600 text-sm">
                            We typically respond within 24-48 hours during business days.
                        </p>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
}; 